import * as React from 'react';

const privacySections: { heading: string; body: string[] }[] = [
  {
    heading: 'Who we are',
    body: [
      'This website is operated by Tour de Cure (The Trustee for Tour de Cure Trust, ABN 56 302 713 357) for the NextOnVera initiative. Tour de Cure is bound by the Privacy Act 1988 (Cth) and the Australian Privacy Principles.'
    ]
  },
  {
    heading: 'What we collect',
    body: [
      'If you use a form on this site, it opens an email from your own email client to info@nextonvera.com; we receive whatever you choose to send, usually your name, email address, organisation and message.',
      'If you donate, your details are collected by Raisely on behalf of Tour de Cure to process the gift and issue a receipt.',
      'We also collect standard website analytics through Google Analytics, such as pages visited, device type and approximate location, which we use only to understand how the site is used.'
    ]
  },
  {
    heading: 'Why we collect it',
    body: [
      'To respond to your enquiry, to process and receipt donations, to keep you informed about NextOnVera and Tour de Cure programs where you have asked us to, and to improve the site.'
    ]
  },
  {
    heading: 'Who we share it with',
    body: [
      'Raisely (donation processing) and Google (analytics), each under their own privacy terms; Tour de Cure staff and contractors who need it to respond to you; and anyone else only where the law requires. Some of these providers store information outside Australia. We do not sell personal information.'
    ]
  },
  {
    heading: 'Health information',
    body: [
      'This site does not collect health information. If you choose to include health information in a message to us, we will use it only to respond to you and will not add it to any research database.'
    ]
  },
  {
    heading: 'Marketing',
    body: [
      'We will only send you news about NextOnVera or Tour de Cure if you have asked for it, and every message will include a way to unsubscribe.'
    ]
  },
  {
    heading: 'Security and retention',
    body: [
      'We keep personal information only as long as needed for the purposes above or as the law requires, and we protect it with reasonable security measures.'
    ]
  },
  {
    heading: 'Access, correction and complaints',
    body: [
      'You can ask to see or correct the personal information we hold about you, or make a privacy complaint, by emailing info@nextonvera.com. We will respond within 30 days. If you are not satisfied, you can contact the Office of the Australian Information Commissioner at oaic.gov.au.'
    ]
  },
  {
    heading: 'Changes',
    body: ['We will post any changes to this policy on this page. Last updated September 2026.']
  }
];

export function PrivacyPage() {
  React.useEffect(() => {
    const previous = document.title;
    document.title = 'Privacy Policy | NextOnVera';
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <article className="px-4 py-14 sm:px-6 sm:py-16 lg:px-8">
      <div className="mx-auto w-full max-w-3xl">
        <p className="text-primary mb-3 text-xs font-medium tracking-[0.2em] uppercase">Legal</p>
        <h1 className="font-display text-foreground text-4xl font-semibold tracking-tight sm:text-5xl">
          Privacy Policy
        </h1>
        <p className="text-muted-foreground mt-5 text-base leading-relaxed sm:text-lg">
          How this website handles your personal information.
        </p>
        <div className="mt-10 space-y-8">
          {privacySections.map((section) => (
            <section key={section.heading}>
              <h2 className="font-display text-foreground text-xl font-semibold tracking-tight">
                {section.heading}
              </h2>
              <div className="mt-3 space-y-3">
                {section.body.map((paragraph) => (
                  <p
                    key={paragraph}
                    className="text-muted-foreground text-base leading-relaxed"
                  >
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </article>
  );
}
